/*
 * Brinde por valor mínimo — Umore
 *
 * Configuração: Configurações do tema > Brinde (window.umoreGiftSettings, montado em
 * layout/theme.liquid). Popup: snippets/gift-popup.liquid. Linha do brinde e aviso
 * "escolher meu brinde" no carrinho: snippets/cart-line-items.liquid.
 *
 * Fluxo:
 *   1. Subtotal (sem contar o próprio brinde) atinge o mínimo:
 *      - uma única variante disponível: o brinde entra sozinho e o popup avisa;
 *      - mais de uma: o popup abre para a cliente escolher (ex.: tamanho).
 *   2. Subtotal cai abaixo do mínimo: o brinde sai (o produto custa R$ 0,00, então
 *      ficar com ele sem atingir o mínimo seria brinde de graça).
 *   3. A quantidade fica travada em 1 e só existe uma linha de brinde.
 *   4. Se a cliente tirar o brinde na mão, não insistimos; o aviso no carrinho continua
 *      oferecendo o botão "Escolher meu brinde".
 *
 * A linha do brinde é marcada com a propriedade `_brinde` (o "_" esconde no carrinho e
 * no checkout). Qualquer linha do produto do brinde também conta como brinde.
 *
 * O produto do brinde é cadastrado com preço R$ 0,00 (o "de" fica em Comparar com).
 */

(function () {
  var cfg = window.umoreGiftSettings;
  if (!cfg || !cfg.threshold || !cfg.variants || !cfg.variants.length) return;

  var GIFT_PROPERTY = '_brinde';
  var KEY_ADDED = 'umore:gift:added';         // nós colocamos o brinde nesta sessão
  var KEY_DISMISSED = 'umore:gift:dismissed'; // a cliente tirou o brinde na mão
  var KEY_PROMPTED = 'umore:gift:prompted';   // o popup de escolha já abriu sozinho

  var busy = false;
  var syncing = false;
  var pendingSync = false;
  var memory = {};

  /* ---------------------------------------------------------------- utilidades */

  function read(key) {
    try {
      var v = sessionStorage.getItem(key);
      return v === null ? memory[key] || null : v;
    } catch (e) {
      return memory[key] || null;
    }
  }

  function store(key, value) {
    if (value === null) delete memory[key];
    else memory[key] = value;
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cfg.currency || 'BRL' })
        .format(Math.max(0, cents) / 100);
    } catch (e) {
      return 'R$ ' + (Math.max(0, cents) / 100).toFixed(2).replace('.', ',');
    }
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          var err = new Error((data && (data.description || data.message)) || 'cart error');
          throw err;
        });
      }
      return r.json();
    });
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  // O custom.js já intercepta /cart/add e /cart/change e recarrega o drawer. Aqui cobrimos
  // os casos sem drawer (página /cart).
  function refreshTheme() {
    var themeCart = window.cart;
    if (themeCart && themeCart.cartDrawer) return; // custom.js cuida
    if (themeCart && typeof themeCart.getCart === 'function') {
      themeCart.getCart();
      return;
    }
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  /* ---------------------------------------------------------------- estado */

  // Linhas de brinde: as marcadas com _brinde e também qualquer linha do produto do
  // brinde (ele custa R$ 0,00 e poderia ser adicionado pela URL do produto).
  function giftLines(cart) {
    return (cart.items || []).filter(function (item) {
      return (item.properties && item.properties[GIFT_PROPERTY]) ||
        (cfg.productId && item.product_id === cfg.productId);
    });
  }

  // Desconta o próprio brinde, senão ele seguraria o carrinho acima do mínimo.
  function qualifyingSubtotal(cart) {
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price || 0;
    giftLines(cart).forEach(function (item) {
      subtotal -= item.final_line_price != null ? item.final_line_price : item.line_price || 0;
    });
    return Math.max(0, subtotal);
  }

  function availableVariants() {
    return cfg.variants.filter(function (v) { return v.available; });
  }

  /* ---------------------------------------------------------------- carrinho */

  function addGift(variantId) {
    busy = true;
    var props = {};
    props[GIFT_PROPERTY] = 'true';

    return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: props }] })
      .then(function () {
        store(KEY_ADDED, '1');
        store(KEY_DISMISSED, null);
        refreshTheme();
      })
      .finally(function () { busy = false; });
  }

  // Zera as linhas indicadas (por key) de uma vez.
  function setQuantities(updates) {
    busy = true;
    return post('cart/update.js', { updates: updates })
      .then(function () { refreshTheme(); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  /* ---------------------------------------------------------------- popup */

  var popup = null;
  var selectedVariant = null;

  function popupEl(sel) {
    return popup ? popup.querySelector(sel) : null;
  }

  function setState(state) {
    if (popup) popup.setAttribute('data-state', state);
  }

  function showError(message) {
    var el = popupEl('[data-gift-popup-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.removeAttribute('hidden');
    } else {
      el.textContent = '';
      el.setAttribute('hidden', '');
    }
  }

  // Usa o rótulo do botão (só as opções que variam, ex.: "PP" em vez de "cropped / PP").
  function labelFor(variant) {
    if (!variant) return '';
    var btn = popup && popup.querySelector('[data-gift-variant="' + variant.id + '"]');
    return (btn && btn.getAttribute('data-gift-variant-title')) || variant.title || '';
  }

  function setVariantLabel(title) {
    var el = popupEl('[data-gift-popup-variant]');
    if (el) el.textContent = cfg.singleDefault || !title ? '' : title;
  }

  function openPopup(state, variant) {
    if (!popup) return;
    setState(state);
    showError(null);

    if (state === 'choose') {
      selectedVariant = null;
      popup.querySelectorAll('[data-gift-variant]').forEach(function (btn) {
        btn.setAttribute('aria-checked', 'false');
        btn.classList.remove('is-selected');
      });
      var confirm = popupEl('[data-gift-popup-confirm]');
      if (confirm) confirm.disabled = true;
      setVariantLabel('');
    } else if (variant) {
      setVariantLabel(labelFor(variant));
    }

    popup.removeAttribute('hidden');
    document.documentElement.classList.add('umore-gift-open');
    requestAnimationFrame(function () { popup.classList.add('is-visible'); });

    var focusTarget = state === 'choose'
      ? popup.querySelector('[data-gift-variant]:not([disabled])')
      : popup.querySelector('.umore-gift-popup__added [data-gift-popup-close]');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }

  function closePopup() {
    if (!popup || popup.hasAttribute('hidden')) return;
    popup.classList.remove('is-visible');
    document.documentElement.classList.remove('umore-gift-open');
    setTimeout(function () { popup.setAttribute('hidden', ''); }, 250);
  }

  // Oferece o brinde: entra direto quando só há uma opção, senão abre a escolha.
  function offerGift() {
    var options = availableVariants();
    if (!options.length) return Promise.resolve();
    if (options.length === 1) {
      return addGift(options[0].id)
        .then(function () { openPopup('added', options[0]); })
        .catch(function () {});
    }
    openPopup('choose');
    return Promise.resolve();
  }

  function onConfirm() {
    if (!selectedVariant || busy) return;
    var confirm = popupEl('[data-gift-popup-confirm]');
    if (confirm) confirm.disabled = true;
    showError(null);

    // Confere de novo antes de adicionar: o carrinho pode ter mudado com o popup aberto.
    fetchCart()
      .then(function (cart) {
        if (giftLines(cart).length) {
          openPopup('added', selectedVariant);
          return;
        }
        if (qualifyingSubtotal(cart) < cfg.threshold) {
          closePopup();
          return;
        }
        var chosen = selectedVariant;
        return addGift(chosen.id).then(function () { openPopup('added', chosen); });
      })
      .catch(function (err) {
        showError(err && err.message ? err.message : 'Não foi possível adicionar o brinde. Tente novamente.');
        if (confirm) confirm.disabled = false;
      });
  }

  function showToast(message) {
    if (!message) return;
    var old = document.querySelector('.umore-gift-toast');
    if (old) old.remove();
    var toast = document.createElement('div');
    toast.className = 'umore-gift-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, 4500);
  }

  /* ---------------------------------------------------------------- sincronização */

  function sync() {
    if (busy || syncing) {
      pendingSync = true;
      return;
    }
    syncing = true;
    pendingSync = false;

    fetchCart()
      .then(function (cart) {
        var lines = giftLines(cart);
        var reached = qualifyingSubtotal(cart) >= cfg.threshold;

        // 1. Abaixo do mínimo: o brinde sai e a sessão "zera" para oferecer de novo.
        if (!reached) {
          store(KEY_PROMPTED, null);
          store(KEY_DISMISSED, null);
          if (lines.length && cfg.autoRemove) {
            var off = {};
            lines.forEach(function (l) { off[l.key] = 0; });
            store(KEY_ADDED, null);
            return setQuantities(off).then(function () {
              showToast((cfg.removedText || '').replace(/\[valor\]/g, money(cfg.threshold)));
            });
          }
          return;
        }

        // 2. Já tem brinde: trava em 1 unidade e uma linha só.
        if (lines.length) {
          var fix = {};
          var needsFix = false;
          lines.forEach(function (l, i) {
            var qty = i === 0 ? 1 : 0;
            if (l.quantity !== qty) {
              fix[l.key] = qty;
              needsFix = true;
            }
          });
          if (needsFix) return setQuantities(fix);
          return;
        }

        // 3. Atingiu o mínimo e não tem brinde.
        if (read(KEY_ADDED) === '1') {
          // Nós tínhamos colocado e ele sumiu: a cliente tirou na mão. Respeitamos.
          store(KEY_ADDED, null);
          store(KEY_DISMISSED, '1');
          return;
        }
        if (read(KEY_DISMISSED) === '1') return;

        var options = availableVariants();
        if (options.length === 1) return offerGift();
        // Várias opções: o popup abre sozinho uma vez; depois fica o aviso no carrinho.
        if (options.length > 1 && read(KEY_PROMPTED) !== '1') {
          store(KEY_PROMPTED, '1');
          openPopup('choose');
        }
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
        if (pendingSync) setTimeout(sync, 300);
      });
  }

  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 250);
  }

  /* ---------------------------------------------------------------- init */

  function init() {
    popup = document.querySelector('[data-gift-popup]');

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;

      if (target.closest('[data-gift-popup-close]')) {
        e.preventDefault();
        closePopup();
        return;
      }

      var variantBtn = target.closest('[data-gift-variant]');
      if (variantBtn && popup && popup.contains(variantBtn)) {
        if (variantBtn.disabled) return;
        popup.querySelectorAll('[data-gift-variant]').forEach(function (btn) {
          var on = btn === variantBtn;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        selectedVariant = {
          id: variantBtn.getAttribute('data-gift-variant'),
          title: variantBtn.getAttribute('data-gift-variant-title')
        };
        var img = variantBtn.getAttribute('data-gift-variant-image');
        var imgEl = popupEl('[data-gift-popup-image]');
        if (img && imgEl) imgEl.src = img;
        setVariantLabel(selectedVariant.title);
        var confirm = popupEl('[data-gift-popup-confirm]');
        if (confirm) confirm.disabled = false;
        return;
      }

      if (target.closest('[data-gift-popup-confirm]')) {
        e.preventDefault();
        onConfirm();
        return;
      }

      // Aviso no carrinho ("Escolher meu brinde").
      if (target.closest('[data-gift-open]')) {
        e.preventDefault();
        store(KEY_DISMISSED, null);
        offerGift();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // theme:cart:added é disparado pelo tema ao fim de todo rebuild do carrinho
    // (adicionar, alterar quantidade, remover).
    ['theme:cart:added', 'theme:cart:loaded'].forEach(function (name) {
      document.addEventListener(name, scheduleSync);
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
